import { Trash2 } from 'lucide-react';
import { FC, ReactNode, useState } from 'react';
export interface ChipModel {
    label: string;
    value: ReactNode;
    onDelete: () => void;
}
interface ChipProps {
    key: number;
    chip: ChipModel;
    borderColor?: string;
    boxShadowColor?: string;
    labelColor?: string;
    valueColor?: string;
    backgroundColor?: string;
    maxHeight?: string;
    deleteIconColor?: string;
    deleteIconHoverColor?: string;
    deleteIconHoverShadow?: string;
    transitionDuration?: string;
}
const Chip: FC<ChipProps> = ({
  key,
  chip,
  borderColor,
  boxShadowColor,
  labelColor,
  valueColor,
  backgroundColor,
  maxHeight = '30px',
  deleteIconColor,
  deleteIconHoverColor,
  deleteIconHoverShadow,
  transitionDuration = '0.3s'
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const hasColorOverrides = Boolean(
    borderColor || boxShadowColor || labelColor || valueColor || backgroundColor
  );
  const hasDeleteIconOverrides = Boolean(deleteIconColor || deleteIconHoverColor);
  return (
    <div
      key={key}
      className={
        'flex items-center gap-x-1.5 rounded-full px-3 py-1 text-sm ' +
        (hasColorOverrides
          ? ''
          : 'border border-secondary-100 bg-secondary-50 dark:border-white/10 dark:bg-darkLight')
      }
      style={
        hasColorOverrides
          ? {
            backgroundColor,
            border: borderColor,
            boxShadow: boxShadowColor,
            maxHeight
          }
          : { maxHeight }
      }
    >
      <span
        className={hasColorOverrides ? '' : 'text-inkMuted dark:text-inkMuted-dark'}
        style={hasColorOverrides ? { color: labelColor } : undefined}
      >
        {chip.label}
      </span>
      <span
        className={hasColorOverrides ? '' : 'font-medium text-secondary-700 dark:text-secondary-200'}
        style={hasColorOverrides ? { color: valueColor } : undefined}
      >
        {chip.value}
      </span>
      <Trash2
        size={13}
        onClick={() => chip.onDelete()}
        className={
          'ml-1 cursor-pointer transition ' +
          (hasDeleteIconOverrides ? '' : 'text-red-500 hover:text-red-600 dark:text-red-400')
        }
        style={
          hasDeleteIconOverrides
            ? {
              color: isHovered ? deleteIconHoverColor : deleteIconColor,
              transition: `all ${transitionDuration} ease`,
              filter: isHovered ? deleteIconHoverShadow : 'none',
              transform: isHovered ? 'scale(1.1)' : 'scale(1)'
            }
            : undefined
        }
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      />
    </div>
  );
};

export default Chip;
